import { initializeJogger } from './initializeJogger';
import { JQueryWrapper } from '../JQueryWrapper';

export const Jogger = ({ robotAppsService }) => {
  return JQueryWrapper({ executeJQueryLogic: () => initializeJogger(robotAppsService) });
};
